import React from 'react';
import { Helmet } from 'react-helmet-async';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import PageHeader from '../PageHeader';

const Pengadaan = () => (
    <>
        <Helmet>
            <title>Pengadaan | PT Len Telekomunikasi Indonesia</title>
            <meta name="description" content="Informasi proses pengadaan barang dan jasa PT Len Telekomunikasi Indonesia." />
        </Helmet>
        <PageHeader title="Pengadaan" />
        <main className="bg-slate-50 py-10 sm:py-14 lg:py-16">
            <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <section className="overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-[0_22px_60px_rgba(15,23,42,0.08)]">
                    <div className="grid lg:grid-cols-[0.42fr_1fr]">
                        <div className="bg-gradient-to-br from-slate-950 via-[#0a213a] to-[#07598e] p-7 text-white sm:p-9 lg:p-10">
                            <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-300">Procurement</span>
                            <h1 className="mt-4 text-3xl font-bold leading-tight sm:text-4xl">Proses Pengadaan Barang dan Jasa</h1>
                            <p className="mt-5 text-sm leading-7 text-slate-300 sm:text-base">
                                Diagram proses pengadaan resmi PT Len Telekomunikasi Indonesia dapat diperbesar untuk melihat setiap tahapan dengan lebih jelas.
                            </p>
                            <a
                                href="/assets-web/flowchart-pengadaan.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-7 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.08] px-5 py-3 text-sm font-semibold text-white transition hover:bg-white/[0.14]"
                            >
                                Buka PDF
                                <span aria-hidden="true">&rarr;</span>
                            </a>
                        </div>
                        <div className="bg-slate-100 p-4 sm:p-7 lg:p-9">
                            <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white p-2 shadow-sm">
                                <Zoom>
                                    <img
                                        src="/assets-web/flowchart-pengadaan.png"
                                        alt="Flow Chart Pengadaan Barang dan Jasa PT Len Telekomunikasi Indonesia"
                                        className="block h-auto w-full cursor-zoom-in object-contain"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </Zoom>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    </>
);

export default Pengadaan;
